<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12" class="document-view">
                <b-card class="mt-0" body-class="pt-0">
                    <b-card class="mt-0">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-row>
                                <b-col>
                                    <b-link v-b-toggle.accordion-general>
                                        Xem chi tiết thông tin tài sản đã gửi lên
                                        <span class="when-opened pull-right">
                                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                        </span>
                                        <span class="when-closed pull-right">
                                            <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                        </span>
                                    </b-link>
                                </b-col>
                            </b-row>
                        </b-card-header>
                        <b-collapse id="accordion-general" visible role="tabpanel">
                            <b-card-body>
                                <b-row>
                                    <b-col sm="6">
                                        <b-form-group label="Mã tài sản tại PM nghiệp vụ:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="asset.syncId" :title="asset.syncId" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group label="Mã tài sản tại kho:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="asset.code" :title="asset.code" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group label="Tên xe:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left"
                                                      v-if="asset.assetTypeGroupId == asset_type_vehicle">
                                            <b-form-input :value="asset.assetName" :title="asset.assetName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                        <b-form-group :label="asset.assetTypeGroupId == asset_type_land ? 'Địa chỉ' : 'Tên tài sản:'"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left"
                                                      v-if="asset.assetTypeGroupId == asset_type_other">
                                            <b-form-input :value="asset.assetName" :title="asset.assetName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                        <b-form-group label="Địa chỉ:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left"
                                                      v-if="asset.assetTypeGroupId == asset_type_land">
                                            <b-form-input :value="asset.assetName" :title="asset.assetName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                        <b-form-group label="Tên nhà:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left"
                                                      v-if="asset.assetTypeGroupId == asset_type_house">
                                            <b-form-input :value="asset.assetName" :title="asset.assetName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group label="Phần mềm đồng bộ: "
                                                      label-for="unit"
                                                      class="text-1"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="asset.syncSourceTypeName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group label="Ngày đồng bộ:"
                                                      label-for="address"
                                                      class="text-1"
                                                      :label-cols="4"
                                                      label-align="left"
                                                      :horizontal="true">
                                            <b-form-input :value="asset.syncDate | formatTime" :title="asset.syncDate | formatTime" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group label="Đơn vị quản lý:"
                                                      label-for="region"
                                                      class="text-1"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="asset.unitName" :title="asset.unitName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group label="SL/KL/DT:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left"
                                                      v-if="asset.assetTypeGroupId == asset_type_vehicle">
                                            <b-form-input :value="asset.calculationUnitValue" :title="asset.calculationUnitValue" :readonly="true"></b-form-input>
                                        </b-form-group>
                                        <b-form-group label="Nhóm tài sản:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left"
                                                      v-if="asset.assetTypeGroupId == asset_type_other">
                                            <b-form-input :value="asset.assetTypeName" :title="asset.assetTypeName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                        <b-form-group label="Loại đất:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left"
                                                      v-if="asset.assetTypeGroupId == asset_type_land">
                                            <b-form-input :value="asset.assetTypeName" :title="asset.assetTypeName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                        <b-form-group label="Cấp nhà:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left"
                                                      v-if="asset.assetTypeGroupId == asset_type_house">
                                            <b-form-input :value="asset.assetTypeName" :title="asset.assetTypeName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group label="Tổng GT tịch thu/ xác lập:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="asset.assetValue | currency" :title="asset.assetValue | currency" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group label="Đơn vị tính:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="asset.calculationUnitType" :title="asset.calculationUnitType" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>


                                    <template v-if="asset.assetTypeGroupId == asset_type_vehicle">
                                        <b-col sm="6">
                                            <b-form-group label="Loại xe:"
                                                          label-for="input-unit"
                                                          :label-cols="4"
                                                          :horizontal="true"
                                                          label-align="left">
                                                <b-form-input :value="asset.assetTypeName" :title="asset.assetTypeName" :readonly="true"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="6">
                                            <b-form-group label="Nhãn xe:"
                                                          label-for="input-unit"
                                                          :label-cols="4"
                                                          :horizontal="true"
                                                          label-align="left">
                                                <b-form-input :value="asset.brandName" :title="asset.brandName" :readonly="true"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="6">
                                            <b-form-group label="Biển kiểm soát:"
                                                          label-for="input-unit"
                                                          :label-cols="4"
                                                          :horizontal="true"
                                                          label-align="left">
                                                <b-form-input :value="asset.vehicleRegistrationPlateNumber" :title="asset.vehicleRegistrationPlateNumber" :readonly="true"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="6">
                                            <b-form-group label="Số cầu:"
                                                          label-for="input-unit"
                                                          :label-cols="4"
                                                          :horizontal="true"
                                                          label-align="left">
                                                <b-form-input :value="asset.vehicleNumberOfWheelDrivers" :title="asset.vehicleNumberOfWheelDrivers" :readonly="true"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="6">
                                            <b-form-group label="Số chỗ ngồi:"
                                                          label-for="input-unit"
                                                          :label-cols="4"
                                                          :horizontal="true"
                                                          label-align="left">
                                                <b-form-input :value="asset.vehicleSize | formatNumber" :title="asset.vehicleSize | formatNumber" :readonly="true"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="6">
                                            <b-form-group label="Tải trọng:"
                                                          label-for="input-unit"
                                                          :label-cols="4"
                                                          :horizontal="true"
                                                          label-align="left">
                                                <b-form-input :value="asset.vehicleCapacity | formatNumber" :title="asset.vehicleCapacity | formatNumber" :readonly="true"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </template>
                                    <template v-if="asset.assetTypeGroupId == asset_type_house">
                                        <b-col sm="6">
                                            <b-form-group label="Địa chỉ:"
                                                          label-for="input-unit"
                                                          :label-cols="4"
                                                          :horizontal="true"
                                                          label-align="left">
                                                <b-form-input :value="asset.houseAddress" :title="asset.houseAddress" :readonly="true"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="6">
                                            <b-form-group label="Thuộc khuôn viên đất:"
                                                          label-for="input-unit"
                                                          :label-cols="4"
                                                          :horizontal="true"
                                                          label-align="left">
                                                <b-form-input :value="asset.landAddress" :title="asset.landAddress" :readonly="true"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="6">
                                            <b-form-group label="Năm đưa vào sử dụng:"
                                                          label-for="input-unit"
                                                          :label-cols="4"
                                                          :horizontal="true"
                                                          label-align="left">
                                                <b-form-input :value="asset.houseBuiltYear" :title="asset.houseBuiltYear" :readonly="true"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="6">
                                            <b-form-group label="Diện tích sàn sử dụng:"
                                                          label-for="input-unit"
                                                          :label-cols="4"
                                                          :horizontal="true"
                                                          label-align="left">
                                                <b-form-input :value="formatArea(asset.houseAreaBuilding)" :title="formatArea(asset.houseAreaBuilding)" :readonly="true"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </template>
                                    <template v-if="asset.assetTypeGroupId == asset_type_land">
                                        <b-col sm="6">
                                            <b-form-group label="Diện tích:"
                                                          label-for="input-unit"
                                                          :label-cols="4"
                                                          :horizontal="true"
                                                          label-align="left">
                                                <b-form-input :value="formatArea(asset.calculationUnitValue)" :title="formatArea(asset.calculationUnitValue)" :readonly="true"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </template>
                                    <template v-if="asset.assetTypeGroupId == asset_type_other">
                                        <b-col sm="6">
                                            <b-form-group label="Giá trị tính:"
                                                          label-for="input-unit"
                                                          :label-cols="4"
                                                          :horizontal="true"
                                                          label-align="left">
                                                <b-form-input :value="asset.calculationUnitValue" :title="asset.calculationUnitValue" :readonly="true"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </template>

                                </b-row>
                                <b-row>
                                    <b-col sm="12">
                                        <b-form-group label="Ghi chú:"
                                                      label-for="input-unit"
                                                      :label-cols="2"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <input-auto-size :value="asset.notes"></input-auto-size>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                    <b-card v-if="asset.decisionNumber">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-row>
                                <b-col>
                                    <b-link v-b-toggle.accordion-confiscate-decision>
                                        Thông tin quyết định tịch thu/ xác lập
                                        <span class="when-opened pull-right">
                                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                        </span>
                                        <span class="when-closed pull-right">
                                            <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                        </span>
                                    </b-link>
                                </b-col>
                            </b-row>
                        </b-card-header>
                        <b-collapse id="accordion-confiscate-decision" visible role="tabpanel">
                            <b-card-body>
                                <b-row>
                                    <b-col sm="6">
                                        <b-form-group label="Số quyết định:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="asset.decisionNumber" :title="asset.decisionNumber" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group label="Tên vụ việc:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="asset.decisionName" :title="asset.decisionName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="6">
                                        <b-form-group label="Ngày quyết định:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="asset.decisionDate | formatDate" :title="asset.decisionDate | formatDate" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group label="Thuộc Bộ/ Tỉnh:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="asset.decisionIssuedUnitName" :title="asset.decisionIssuedUnitName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="6">
                                        <b-form-group label="Ngày tạo:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="asset.decisionCreatedDate | formatDate" :title="asset.decisionCreatedDate | formatDate" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group label="Chức danh người QĐ:"
                                                      label-for="input-unit"
                                                      :label-cols="4"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="asset.decisionCreator" :title="asset.decisionCreator" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="12">
                                        <b-form-group label="Ghi chú:"
                                                      label-for="input-unit"
                                                      :label-cols="2"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <input-auto-size :value="asset.decisionNotes"></input-auto-size>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                    <b-card>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-row>
                                <b-col>
                                    <b-link v-b-toggle.accordion-asset-handlings>
                                        Thông tin xử lý tài sản
                                        <span class="when-opened pull-right">
                                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                        </span>
                                        <span class="when-closed pull-right">
                                            <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                        </span>
                                    </b-link>
                                </b-col>
                            </b-row>
                        </b-card-header>
                        <b-collapse id="accordion-asset-handlings" visible role="tabpanel">
                            <b-card-body style="padding-bottom: 0; padding-left: 0; padding-right: 0; margin-bottom: 0">
                                <b-grid :items="asset.assetHandlings"
                                        :gridOptions="gridOptions"
                                        gridName=""
                                        ref="assetInventoryDetailTable">
                                    <template v-slot:cell(decisionNumber)="row">
                                        <router-link :to="{ path: `/data/national-public-assets/asset-handlings/${row.item.id}` }">
                                            {{ row.value }}
                                        </router-link>
                                    </template>
                                    <template v-slot:cell(originalValue)="row">
                                        {{ row.value | currency }}
                                    </template>
                                    <template v-slot:cell(residualValue)="row">
                                        {{ row.value | currency }}
                                    </template>
                                    <template v-slot:cell(increasementValue)="row">
                                        {{ row.value | currency }}
                                    </template>
                                    <template v-slot:cell(valueObtained)="row">
                                        {{ row.value | currency }}
                                    </template>
                                    <template v-slot:cell(valueToBudget)="row">
                                        {{ row.value | currency }}
                                    </template>
                                    <template v-slot:cell(valueTKTG)="row">
                                        {{ row.value | currency }}
                                    </template>
                                    <template v-slot:cell(handlingCost)="row">
                                        {{ row.value | currency }}
                                    </template>
                                    <template v-slot:cell(handlingDate)="row">
                                        {{ row.value | formatDate }}
                                    </template>
                                    <template v-slot:cell(contractDate)="row">
                                        {{ row.value | formatDate }}
                                    </template>
                                    <template v-slot:cell(quantity)="row">
                                        {{ row.value | formatNumber }}
                                    </template>
                                    <template v-slot:cell(volume)="row">
                                        {{ row.value | formatNumber }} g
                                    </template>
                                    <template v-slot:cell(area)="row">
                                        {{ row.value | formatNumber }} m
                                        <sup>2</sup>
                                    </template>
                                    <template v-slot:cell(_actions)="row">
                                        <b-button size="sm" @click="row.toggleDetails" v-if="!row.detailsShowing" title="Xem" variant="info">
                                            Xem
                                        </b-button>
                                        <b-button size="sm" @click="row.toggleDetails" v-if="row.detailsShowing" title="Ẩn chi tiết" variant="info">
                                            Ẩn chi tiết
                                        </b-button>
                                        <!--<b-button size="sm" @click="row.toggleDetails" class="mr-2">
                                            <i class="fa fa-eye" v-if="!row.detailsShowing" title="Xem chi tiết"></i>
                                            <i class="fa fa-eye-slash" v-else title="Ẩn chi tiết"></i>
                                        </b-button>-->
                                    </template>
                                    <template v-slot:row-details="row">
                                        <b-card>
                                            <b-row>
                                                <b-col sm="6">
                                                    <b-form-group label="Quyết định xử lý:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.decisionNumber" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col sm="6">
                                                    <b-form-group label="Ngày quyết định:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.decisionDate | formatDate" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col sm="6">
                                                    <b-form-group label="Ngày xử lý:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.handlingDate | formatDate" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col sm="6">
                                                    <b-form-group label="Số lượng:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.quantity | formatNumber" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col sm="6">
                                                    <b-form-group label="Diện tích:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="formatArea(row.item.area)" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col sm="6">
                                                    <b-form-group label="Khối lượng:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="formatVolume(row.item.volume)" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col sm="6">
                                                    <b-form-group label="Tổng GT tịch thu/ xác lập:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.originalValue | currency" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col sm="6">
                                                    <b-form-group label="Giá trị còn lại:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.residualValue | currency" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col sm="6">
                                                    <b-form-group label="Giá trị ghi tăng:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.increasementValue | currency" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col sm="6">
                                                    <b-form-group label="Số tiền thu được:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.valueObtained | currency" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col sm="6">
                                                    <b-form-group label="Số tiền nộp NSNN:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.valueToBudget | currency" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col sm="6">
                                                    <b-form-group label="Số tiền nộp TKTG:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.valueTKTG | currency" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col sm="6">
                                                    <b-form-group label="Hình thức xử lý:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.handlingFormName" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col sm="6">
                                                    <b-form-group label="Phương thức xử lý:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.handlingMethodName" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col sm="6">
                                                    <b-form-group label="Chi phí xử lý:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.handlingCost | curency" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col sm="6">
                                                    <b-form-group label="Đơn vị nhận điều chuyển:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.transferUnitName" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col sm="6">
                                                    <b-form-group label="Số hợp đồng:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.contractNumber" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col sm="6">
                                                    <b-form-group label="Ngày hợp đồng:"
                                                                  label-for="input-unit"
                                                                  :label-cols="4"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input :value="row.item.contractDate | formatDate" :readonly="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col sm="12">
                                                    <b-form-group label="Ghi chú:"
                                                                  label-for="input-unit"
                                                                  :label-cols="2"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <input-auto-size :value="row.item.notes"></input-auto-size>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-button size="sm" @click="row.toggleDetails">Ẩn chi tiết</b-button>
                                        </b-card>
                                    </template>
                                </b-grid>
                            </b-card-body>
                        </b-collapse>
                        <b-card style="margin-top: 0; padding-top: 0">
                            <b-row>
                                <b-col class="text-center">
                                    <div class="form-group">
                                        <b-button type="button" :to="{ path: '.' }">Quay lại</b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-card>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'NationalPublicAssetDetail',
        mixins: [mixins],
        data() {
            return {
                asset_type_land: 17,//đất
                asset_type_house: 18,//nhà
                asset_type_vehicle: 19,//xe
                asset_type_other: 20,//khác
                searchForm: {
                    filter: null
                },
                gridOptions: {
                    fields: [
                        { key: 'decisionNumber', label: 'Số QĐ phê duyệt PAXL', sortable: true, sortDirection: 'asc', thAttr: { width: 160 } },
                        { key: 'handlingDate', label: 'Ngày xử lý', sortable: true },
                        { key: 'valueObtained', label: 'Giá trị TS tại PAXL', sortable: true, tdClass: 'text-right' },
                        { key: 'handlingFormName', label: 'Hình thức xử lý', sortable: true },
                        { key: 'handlingMethodName', label: 'Phương thức xử lý', sortable: true },
                    ],
                    sortBy: 'handlingDate',
                },
                asset: {

                }
            }
        },
        computed: {
            assetId() {
                return this.$route.params.assetId;
            }
        },
        created() {
            this.loadAssetDetail();
        },
        methods: {
            loadAssetDetail() {
                var vm = this;
                return this.$services.get(`data/national-public-assets/${this.assetId}`).done(data => {
                    vm.asset = data;
                });
            },
            formatArea(val) {

                return val ? this.$options.filters.formatNumber(val) + ' m²' : null;
            },
            formatVolume(val) {
                return val ? this.$options.filters.formatNumber(val) + ' g' : null;
            }
        },
        watch: {
            assetId() {
                this.loadAssetDetail();;
            }
        }
    }
</script>
<style scoped>
    ul {
        columns: 2;
        -webkit-columns: 2;
        -moz-columns: 2;
    }

    .card {
        margin-bottom: 0;
        margin-top: 1.5rem;
        border: none;
    }
</style>
